import React from 'react';
import {motion} from 'framer-motion';
import {fadeIn} from '../variants';
import Img2 from '../assets/a1.png';
import Img3 from '../assets/a2.png';
import Img1 from '../assets/a3.png';

const Work = () => {
    return (
        <section className='section min-h-[89vh] xl:min-h[700px] lg:min-h-[800px]' id='work'>
            <div className="container mx-auto">
                <div className='flex flex-col lg:flex-row gap-x-10'>
                    <motion.div
                        variants={fadeIn('right', 0.3)}
                        initial="hidden"
                        whileInView={'show'}
                        viewport={{amount: 0.3, once: true}}
                        className="flex-1 flex flex-col gap-y-10 mb-10 ">
                        <div className='flex flex-col xl:min-h-[320px] lg:min-h-[250px]'>
                            <h1 className='my-4 text-[36px] lg:text-[60px] uppercase leading-[1] text-bg inline-block'>
                        Our latest work:
                            </h1>
                            <p className='max-w-sm mb-0'>Beside our groundbreaking work with ETHLEND and the FAA, we've been hard at work crafting innovative solutions for an array of visionary partners. These projects embody the essence of cutting-edge technology. While we can't spill all the beans just yet, here's a sneak peek of our latest triumphs:</p>
                        </div>
                        <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                            <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                            <a href='https://github.com/vmlabss/SHAP-smart-health-assistant-program-' target='_blank' rel='noopener noreferrer'>
                                <img className='group-hover:scale-125 transition-all duration-500' src={Img1} alt=''/>
                                <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                                    <span className='text-WHITE'>-smart-health-assistant-Application</span>
                                </div>
                                <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-500 z-50'>
                                    <span className='text-3xl text-white'>S.H.A.A.P.</span>
                                </div>
                            </a>
                        </div>
                    </motion.div>
                    <motion.div

                        variants={fadeIn('left', 0.2)}
                        initial="hidden"
                        whileInView={'show'}
                        viewport={{amount: 0.3, once: true}}
                        className='flex-1 flex flex-col gap-y-10'>
                        <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                            <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                            <a href='https://github.com/vmlabss/PDGP-encryption-model' target='_blank' rel='noopener noreferrer'>
                                <img className='group-hover:scale-125 transition-all duration-500' src={Img2} alt=''/>
                                <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                                    <span className='text-WHITE'> In house encryption model inspired by PGP </span>
                                </div>
                                <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-500 z-50'>
                                    <span className='text-3xl text-white'>P.D.G.P (pretty damn good privacy) </span>
                                </div>
                            </a>
                        </div>
                        <div className='group relative overflow-hidden border-2 border-white/50 rounded-xl'>
                            <div className='group-hover:bg-black/70 w-full h-full absolute z-40 transition-all duration-300'></div>
                            <a href='https://kovanice.web.app/' target='_blank' rel='noopener noreferrer'>
                                <img className='group-hover:scale-125 transition-all duration-500' src={Img3} alt=''/>
                                <div className='absolute -bottom-full left-12 group-hover:bottom-24 transition-all duration-500 z-50'>
                                    <span className='text-WHITE'>Kovanice provides cryptocurrency and NFT prices, News, and much more.</span>
                                </div>
                                <div className='absolute -bottom-full left-12 group-hover:bottom-14 transition-all duration-500 z-50'>
                                    <span className='text-3xl text-white'>KOVANICE.HR</span>
                                </div>
                            </a>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    )
};

export default Work;